import React from 'react';
import { render } from 'react-dom';
import VisionfulApp from './App';
import 'antd/dist/antd.css';
import 'react-day-picker/dist/style.css';

import reportWebVitals from './reportWebVitals';

render(
  <React.StrictMode>
    <VisionfulApp />
  </React.StrictMode>,
  document.getElementById('root') as HTMLElement,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
